import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ChevronLeft, ChevronRight, Calendar, MapPin, Plus, Info, BarChart3,
  Users, Mail, Map as MapIcon, FileText,
} from "lucide-react";

const REGOLAMENTO_URL = "https://drive.google.com/file/d/1QiqCzCttslH0GuAxxiklYx-X-q2Ee88c/view";
import { api } from "@/lib/api";
import { formatDateShort } from "@/lib/format";
import { Logo } from "@/components/Logo";
import { BottomTab } from "@/components/BottomTab";

export default function EventHome() {
  const nav = useNavigate();
  const [event, setEvent] = useState(null);

  useEffect(() => {
    api.get("/event").then((r) => setEvent(r.data)).catch(() => {});
  }, []);

  const Row = ({ icon: Icon, title, subtitle, onClick, highlight, testid, last }) => (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`w-full flex items-center gap-4 px-5 py-4 text-left ${last ? "" : "border-b border-surface3"}`}
    >
      <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 ${highlight ? "bg-brand" : "bg-surface"}`}>
        <Icon size={24} className={highlight ? "text-onbrand" : "text-onsurface"} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-black text-lg text-onsurface leading-tight">{title}</p>
        {subtitle && <p className="text-sm text-onsurface3 font-secondary leading-snug">{subtitle}</p>}
      </div>
      <ChevronRight className="text-onsurface3 shrink-0" size={24} />
    </button>
  );

  const openExternal = (url) => url && window.open(url, "_blank");

  return (
    <div className="min-h-screen pb-24 bg-surface" data-testid="event-home-page">
      <header
        className="bg-black flex items-center px-5 pb-6"
        style={{ paddingTop: "calc(var(--safe-top) + 20px)" }}
      >
        <button data-testid="event-back-btn" onClick={() => nav("/")} className="text-white">
          <ChevronLeft size={34} strokeWidth={2.5} />
        </button>
        <div className="flex-1 flex justify-center">
          <Logo size="md" />
        </div>
        <div className="w-[34px]" />
      </header>

      <div className="px-4 mt-4">
        <div className="bg-black rounded-3xl px-6 py-5">
          <p className="text-brand font-black text-xl tracking-wide leading-tight">
            {(event?.name || "THE MAD BAR").toUpperCase()} — {(event?.subtitle || "First Edition").toUpperCase()}
          </p>
          <div className="mt-3 flex items-center gap-2 text-white">
            <Calendar className="text-brand shrink-0" size={20} />
            <span className="font-bold">{event ? formatDateShort(event.date_iso) : "—"}</span>
          </div>
          <div className="mt-2 flex items-center gap-2 text-white">
            <MapPin className="text-brand shrink-0" size={20} />
            <span className="font-bold">{event?.location_name || "—"}</span>
          </div>
        </div>
      </div>

      <div className="px-4 pt-4">
        <div className="bg-surface2 rounded-3xl overflow-hidden">
          <Row testid="btn-partecipa" icon={Plus} title="Partecipa" subtitle="Iscriviti alla gara" highlight onClick={() => openExternal(event?.signup_url)} />
          <Row testid="btn-dettagli" icon={Info} title="Dettagli" subtitle="Descrizione e format gara" onClick={() => nav("/event/dettagli")} />
          <Row testid="btn-classifica" icon={BarChart3} title="Classifica Live" subtitle="Vedi i risultati in tempo reale" onClick={() => nav("/event/classifica")} />
          <Row testid="btn-iscritti" icon={Users} title="Iscritti" subtitle="Visualizza tutti gli iscritti" onClick={() => nav("/event/iscritti")} />
          <Row testid="btn-maps" icon={MapIcon} title="Location" subtitle={event?.location_address} onClick={() => openExternal(event?.maps_url)} />
          <Row testid="btn-regolamento" icon={FileText} title="Regolamento" subtitle="Leggi il regolamento completo" onClick={() => openExternal(REGOLAMENTO_URL)} />
          <Row testid="btn-contatti" icon={Mail} title="Contatti" subtitle="Scrivi allo staff dell'evento" onClick={() => nav("/event/contatti")} last />
        </div>
      </div>

      <BottomTab />
    </div>
  );
}
